import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-project-member',
  templateUrl: './project-member.component.html',
  styleUrls: ['./project-member.component.css']
})
export class ProjectMemberComponent implements OnInit {
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    this.userD = this.auth.Authention();
  }
  userD: any;
  id_now: number = 1;
  setaddfm: boolean;
  async ngOnInit(): Promise<void> {
    let userD = this.userD;
    console.log('userD:', userD);
    await this.Loadmain_topic(this.year);
    await this.LoadAllFm();
  }

  set_type: number;
  data_se = [];
  Project_list = [];
  year = '2425';
  async Loadmain_topic(year: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[vw_brdProject]&w=yearid=${year}`;
    await axios.get(url).then(res => {
      let data = res.data;
      if (data.length > 0) {
        data.sort(function (a: any, b: any) { return b.dataid - a.dataid });
        this.Project_list = data;
      }
      console.log('Loadmain_topic:', data);
    }).catch(err => { throw (err) })
  }

  AlldataFm1 = [];
  AlldataFm2 = [];
  async LoadAllFm() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=trim(FMCODE_B1)fmcode,trim(fmname)fmname,trim(SUPZONE)[supzone]&f=[CPS6263].[dbo].[t_farmer]&w=area0=1';
    await axios.get(url).then(res => {
      let data = res.data;
      if (data.length >= 1) {
        this.AlldataFm2 = (res.data);
      }
      else {
        alert("ไม่สามารถโหลด ข้อมูลชาวไร่ได้");
      }
    }).catch(err => { throw (err) })
  }

  txtFindIn = '';
  search_dataFM() {//กรองข้อความ
    let keyword = (this.txtFindIn.trim()).toLowerCase();
    if (keyword.length >= 2) {
      this.AlldataFm1 = this.AlldataFm2.filter((el) => (el.fmcode.indexOf(keyword) > -1) || (el.fmname.indexOf(keyword) > -1) || (el.supzone.indexOf(keyword) > -1)) || [];
    }
    else this.AlldataFm1 = [];
  }

  project_id: string;
  member_list = [];
  async Load_projectMem(id: string) {
    this.project_id = id;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/select_sfw?s=*&f=[dbo].[v_projectMember]&w=[project_id]=${id}`;
    await axios.get(url).then(res => {
      let data = res.data;
      if (data.length >= 1) {
        this.member_list = (res.data);
      }
      else {
        this.member_list = [];
        alert("ยังไม่มีสมาชิก");
      }
    }).catch(err => { throw (err) })
  }


  list_landno = [];
  async Load_landno(fmcode: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/select_sfw?s=itid,year,intlandno,fmcode_,fmcode,fmname,supzone,supcode,landvalue_left,canetype&f=[CPS6263].[dbo].[v_cp6768_basic]&w=[fmcode]='${fmcode}'`;
    await axios.get(url).then(res => {
      let data = res.data;
      if (data.length >= 1) {
        this.list_landno = (res.data);
      }
      else {
        this.list_landno = [];
        alert("ไม่พบแปลง");
      }
    }).catch(err => { throw (err) })
  }

  note = '';
  dataAr = [];
  push_arr(type: string, member: string, code: string, name: string, status: string) {
    this.dataAr = this.dataAr.filter(el => el.member != member);
    let pro_id: string = this.project_id;
    let data = { type: '', pro_id: '', member: '', code: '', name: '', status: '' };
    data.type = type; data.pro_id = pro_id; data.member = member, data.code = code, data.name = name, data.status = status;
    this.dataAr.push(data);
  }

  delete_value(member = '') {
    let data = this.dataAr.filter(el => el.member != member);
    this.dataAr = data.sort(function (a, b) {
      return a.member - b.member;
    });
  }

  async insert_member() {
    let note = this.note;
    let value = this.dataAr;
    let userD = this.userD;
    if (value.length > 0) {
      let member = value.map(function (elem) { return elem.member });
      if (confirm('ต้องการบันทึกข้อมูล | จำนวน ' + value.length + ' รายการ หรือไม่?')) {
        for (let i = 0; i < value.length; i++) {
          let url: string, ar0 = value[i];
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/insert_projectMember?[type]=${ar0.type}&[project_id]=${ar0.pro_id}&[member]=${ar0.member}&[note]=${note}&[status]=${ar0.status}&[updBy]=${userD.supcode}`;
          //console.log('URL:', i, url);
          await axios.get(url).then(res => {
            let status = res.status;

          }).catch(err => { throw (err) })
        }
        this.Load_projectMem(this.project_id);
        this.dataAr = [];
      }
    }
  }
}
